export const environment = {
    production: true,
    BASE_URL:'https://www.employee-task.miltiadisntinos.com/api' 
    //BASE_URL:'https://employee-task.miltiadisntinos.com/api' 
    //BASE_URL: 'https://185.188.249.104/api'
    //BASE_URL: 'https://185.188.249.104:443'
    //BASE_URL:'https://employee-task.miltiadisntinos.com' 
    //BASE_URL: 'https://185.188.249.104:9090/api'
    //BASE_URL: 'http://185.188.249.104:9090'
    //BASE_URL: 'http://localhost:9090'
};
